<template>
  <div id="shop-product-item">
    <v-container fluid grid-list-xs>
      <v-layout align-center row wrap>
        <v-flex sm8 xs12>
          <div class="subheading">Product Item</div>
        </v-flex>
        <v-flex sm4 text-xs-center xs12>
          <ShopEditionProductItemDialog />
        </v-flex>
        <v-flex xs12>
          <!-- Data Table -->
          <v-data-table
            class="elevation-0"
            disable-initial-sort
            :headers="headers"
            hide-actions
            :items="states"
            :loading="tableLoading"
          >
            <template slot="items" slot-scope="props">
              <tr @click="editItem(props.item.idx)">
                <td>
                  <v-img
                    aspect-ratio="1"
                    height="40"
                    :src="
                      props.item.picture ? props.item.picture : require('@/assets/NoPicture.png')
                    "
                    width="40"
                  ></v-img>
                </td>
                <td>{{ props.item.name || '-' }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
const ShopEditionProductItemDialog = () => import('@/components/admin/ShopEditionProductItemDialog')
export default {
  name: 'shop-product-item',
  components: {
    ShopEditionProductItemDialog
  },
  data() {
    return {
      tableLoading: false,
      headers: [
        { text: 'Picture', align: 'left', value: 'picture', width: '50' },
        { text: 'Name', align: 'left', value: 'name', width: '300' }
      ]
    }
  },
  computed: {
    states() {
      return this.$store.getters['ShopEditionProductItem/getAll'].filter(
        item => item.shopEditionProductId == this.shopEditionProductId
      )
    },
    shopEditionProductId() {
      return this.$store.state.ShopEditionProduct.idx
    }
  },
  created() {
    if (this.$store.state.ShopEditionProductItem.data.length === 0)
      this.$store.dispatch('ShopEditionProductItem/fetch')
  },
  methods: {
    editItem(idx) {
      this.$store.commit('ShopEditionProductItem/UPDATE_DIALOG', true)
      this.$store.commit('ShopEditionProductItem/SET_IDX', idx)
    }
  }
}
</script>

<style lang="scss" scoped></style>
